import { createSelector } from 'reselect';
import { COLUMN_TYPE, buildColumn } from '../../../common/support/utils';
import type { IColumn } from '../../../common/types/IColumn';
import type { ColumnOptions, GetColumnKeys, GetColumnOptions } from './createColumnsSelector.types';

export const getCalculationColumns = (calculationKeys: string[], options?: ColumnOptions): IColumn[] => {
  return calculationKeys.map((key) => buildColumn({ type: COLUMN_TYPE.FORMULA, key, ...options }));
};

export const createCalculationColumnsSelector = (
  getCalculationKeys: GetColumnKeys,
  getColumnOptions: GetColumnOptions = () => undefined
) => {
  return createSelector(getCalculationKeys, getColumnOptions, getCalculationColumns);
};
